import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ProductStatus } from "@/components/ProductStatus";
import { ReadonlyPictograms } from "@/components/ReadonlyPictograms";

const sections = [
  { key: "brands", name: "Brand", endpoint: "/brands" },
  { key: "categories", name: "Categorie", endpoint: "/categories" },
  { key: "characteristics", name: "Caratteristiche", endpoint: "/characteristics" },
  { key: "pictograms", name: "Pittogrammi", endpoint: "/pictograms" },
];

export const ReadonlyArchives = () => {
  const [tab, setTab] = useState(sections[0]);
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    if (tab.key === "pictograms") { setError(""); return; }
    let active = true;
    setError("");
    api.get(tab.endpoint).then(({ data }) => { if (active) setItems(Array.isArray(data) ? data : data.items || []); })
      .catch(() => { if (active) setError("Impossibile caricare l'archivio."); });
    return () => { active = false; };
  }, [tab]);

  return <div className="workflow-ux p-4 pt-16 md:p-8 lg:p-12" data-testid="readonly-archives">
    <p className="text-xs text-[#707070] uppercase mb-2">Configurazione</p>
    <h1 className="font-serif text-4xl mb-8">Archivi</h1>
    <div className="flex gap-4 border-b border-[#E5E5E0] overflow-x-auto pb-3" role="tablist">
      {sections.map(section => <button key={section.key} role="tab" type="button"
        aria-selected={tab.key === section.key} onClick={() => setTab(section)}
        data-testid={`readonly-archive-tab-${section.key}`}
        className={`text-sm whitespace-nowrap ${tab.key === section.key ? "font-semibold text-[#1A1A1A]" : "text-[#707070]"}`}>
        {section.name}
      </button>)}
    </div>
    {error && <p className="mt-6 text-[#8C3A3A]" role="alert" data-testid="readonly-archives-error">{error}</p>}
    {tab.key === "pictograms" ? <div className="mt-7"><ReadonlyPictograms /></div> : !error && <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="readonly-archives-list">
      {items.map(item => <article key={item.id} className="border border-[#E5E5E0] bg-white p-5 min-w-0" data-testid={`readonly-archive-item-${item.id}`}>
        {item.logo_file_id && <img src={`${process.env.REACT_APP_BACKEND_URL}/api/files/${item.logo_file_id}`}
          alt="" className="w-16 h-16 object-contain mb-3" />}
        {item.icon_file_id && <img src={`${process.env.REACT_APP_BACKEND_URL}/api/files/${item.icon_file_id}`}
          alt="" className="w-10 h-10 object-contain mb-3" />}
        <h2 className="font-serif text-xl break-words">{item.name}</h2>
        {item.company_name && <p className="text-sm mt-2">{item.company_name}</p>}
        {item.parent_id && <p className="text-xs mt-1 text-[#707070]">Sottocategoria</p>}
        {item.description && <p className="text-sm mt-3 break-words">{item.description}</p>}
        {item.email && <p className="text-sm mt-2 break-all">{item.email}</p>}
        {item.vat_number && <p className="text-sm mt-2">P.IVA {item.vat_number}</p>}
        <div className="mt-3"><ProductStatus tone={item.is_active === false ? "danger" : "success"}
                          testId={`readonly-archive-status-${item.id}`}>
          {item.is_active === false ? "Non attivo" : "Attivo"}
        </ProductStatus></div>
      </article>)}
      {items.length === 0 && <p className="text-sm text-[#707070]" data-testid="readonly-archives-empty">Nessun elemento.</p>}
    </div>}
  </div>;
};